/* eslint-disable */
export function sendAnalyticsEvent(event: string, action: string, label = '(not set)') {
  if (!Array.isArray(window.dataLayer)) window.dataLayer = []

  window.dataLayer.push({
    event: 'universal_event',
    event_category: event,
    event_action: action,
    event_label: label,
    universal_event_systems: 'google_analytics'
  })
}
